/* eslint-disable */

import React, { createContext, useEffect, useState, useCallback } from "react";
import { getBallkids, getAllBallkidSchedules } from "../firebaseService";
import { useAuth } from "../AuthContext";
import { useGroup } from "./GroupContext";

// Kontext erstellen
export const BallkidContext = createContext();

export const BallkidProvider = ({ children }) => {
  const { user } = useAuth();
  const { activeGroup } = useGroup();
  const [ballkids, setBallkids] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!user || !activeGroup) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const [ballkidData, allSchedules] = await Promise.all([
        getBallkids(),
        getAllBallkidSchedules(),
      ]);

      const ballkidWithAssignments = ballkidData.map((bk) => ({
        ...bk,
        assignments: allSchedules[bk.id] || [],
      }));
      const sortedData = ballkidWithAssignments.sort((a, b) => a.name.localeCompare(b.name));

      setBallkids(sortedData);
    } catch (error) {
      console.error("Fehler beim Laden der Mitglieder:", error);
      setBallkids([]);
    } finally {
      setLoading(false);
    }
  }, [user, activeGroup]);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <BallkidContext.Provider value={{ ballkids, loading, reload }}>
      {children}
    </BallkidContext.Provider>
  );
};
